module.exports = __webpack_public_path__ + "img/bg_20240814.effe2539.webp";